import { render, staticRenderFns } from "./ClientReleases.vue?vue&type=template&id=d355f454&scoped=true"
import script from "./ClientReleases.vue?vue&type=script&lang=js"
export * from "./ClientReleases.vue?vue&type=script&lang=js"
import style0 from "./ClientReleases.vue?vue&type=style&index=0&id=d355f454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d355f454",
  null
  
)

export default component.exports